import { SettingsIcon } from "components/icons/components/Settings";
import { Link, useLocation } from "react-router-dom";

const Breadcrumbs = () => {
  const location = useLocation();
  const { pathname } = location;
  const segments = pathname.split("/").filter((n: any) => n);

  return (
    <div className="mb-4">
      <nav aria-label="breadcrumb">
        <ul className="flex items-center">
          {segments.map((segment: string, index: number) => {
            const routeTo = `/${segments.slice(0, index + 1).join("/")}`;
            const isLast = index === segments.length - 1;
            return isLast ? (
              <li key={segment} aria-current="page" className="!flex gap-2 items-center justify-center">
                {index === 0 && <SettingsIcon className="mr-2" />}
                {segment}
              </li>
            ) : (
              <>
                <li key={segment}>
                  <Link to={routeTo} className="flex gap-2 items-center justify-center">
                    {index === 0 && <SettingsIcon className="mr-2" />}
                    <p>{segment}</p>
                  </Link>
                </li>
                {!isLast && <span className="mx-2">{">"}</span>}
              </>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Breadcrumbs;
